module.exports = __webpack_public_path__ + "img/logo.25f716b8.png";